module.exports = __webpack_public_path__ + "static/img/materials1.e837ba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materials1.png
// module id = JnnX
// module chunks = 2